export interface ApiGetTechKeywordRequest {
    task_id: string;
    area: string;
    topics: {
        topic_desc: string;
        topic_name: string;
    }[];
}


interface KeywordItem {
    element: string;
    feature?: string[];
    keywords: {
        key: string;
        synonym: string[];
        hyponym: string[];
        related: string[];
    }[];
}

export interface ApiGetTechKeywordResponse {
    areas: KeywordItem[];
    features: KeywordItem[];
    effects: KeywordItem[];
}

export const GetTechKeyword = Symbol('GetTechKeyword');

export interface GetTechKeyword {
    getTechKeyword(data: ApiGetTechKeywordRequest): Promise<ApiGetTechKeywordResponse>;
}